import React, { Component, Fragment } from 'react'
import axios from 'axios'
import '../style.css'
import { connect } from 'react-redux'
import { Button, FormGroup, FormControl, Radio, Row, Col } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import ReactQuill from 'react-quill'
import swal from 'sweetalert'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'
import AuthenticationComponent from '../../../AuthenticationComponent'
import FileUploader from '../../../reuseable-components/file-uploading/FileUploader'
import FileWithOverlay from '../../../reuseable-components/file-uploading/FileWithOverlay'

import { getClients, getUsers } from '../../login/reducers/manageLogin'
import { getSAPResourcesMetadata, formatResourceForServer } from '../reducers/manageSAPResources'

class SAPResourceForm extends Component {

	state = {
		savingResource: false,

		url: null,
		title: '',
		text: '',
		project: '',
		projectFolderPath: '',
		authors: [],
		isProtocol: false,
		isSAP: false,
		externalClient: [],
		removeableDocuments: [],
		documents: [],
		contents: [],
		dataSources: [],
		designs: [],
		methods: [],
		therapeuticAreas: [],
	}

	componentDidMount() {
		if (!Array.isArray(this.props.clients) || this.props.clients.length === 0) {
			this.props.getClients()
		}

		if (!Array.isArray(this.props.genesisUsers) || this.props.genesisUsers.length === 0) {
			this.props.getUsers()
		}

		const metadataShouldBeFetched = (
			(!Array.isArray(this.props.contents) || this.props.contents.length === 0) &&
			(!Array.isArray(this.props.dataSources) || this.props.dataSources.length === 0) &&
			(!Array.isArray(this.props.designs) || this.props.designs.length === 0) &&
			(!Array.isArray(this.props.methods) || this.props.methods.length === 0) &&
			(!Array.isArray(this.props.therapeuticAreas) || this.props.therapeuticAreas.length === 0)
		)

		if (metadataShouldBeFetched) {
			this.props.getSAPResourcesMetadata()
		}

		if (this.props.resource) {
			const { resource } = this.props
			this.setState({
				url: resource.url,
				title: resource.title,
				text: resource.text,
				project: resource.project,
				projectFolderPath: resource.project_folder_path,
				authors: resource.authors,
				isProtocol: resource.is_protocol,
				isSAP: resource.is_sap,
				externalClient: resource.external_client ? [resource.external_client] : [],
				removeableDocuments: resource.documents,
				contents: resource.contents,
				dataSources: resource.data_sources,
				designs: resource.designs,
				methods: resource.methods,
				therapeuticAreas: resource.therapeutic_areas,
			})
		}
	}

	_renderMenuItemChildren = (user, props, index) => {
		// THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
		return [
			<div key="name" search={props.text}>
				<strong>{user.first_name} {user.last_name}</strong>
			</div>,
			<div key="population">
				<small>
					Email: {user.email ? user.email : "N/A"}
				</small>
			</div>,
		]
	}

	handleChange = (name, value) => this.setState({ [name]: value })

	handleProtocolSAPChange = (name, value) => {
		if (name === "isBoth") {
			return this.setState({
				isSAP: true,
				isProtocol: true
			})
		} else if (name === "isSAP") {
			return this.setState({
				isSAP: true,
				isProtocol: false
			})
		} else if (name === "isProtocol") {
			return this.setState({
				isSAP: false,
				isProtocol: true
			})
		}
	}

	addDocuments = (documents) => this.setState({ documents: [...this.state.documents, ...documents]})

	removeDocument = index => this.setState({
		documents: [...this.state.documents.slice(0, index), ...this.state.documents.slice(index + 1)]
	})

	deleteDocument = (documentUrl) => {
		swal({
			text: "Deleting document",
			icon: require("../../../static/images/spinner.gif"),
			button: false
		})
		axios({
			url: documentUrl,
			method: "DELETE",
			headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
		})
			.then(response => {
				swal({
					title: "Document Deleted",
					text: "The document was deleted",
					icon: "success",
					button: "Continue",
				})
				const removeableDocuments = this.state.removeableDocuments.filter(doc => doc.url !== documentUrl)
				this.setState({ removeableDocuments })
			})
			.catch(error => {
				const message = 'There was an error deleting the document.'
				handleErrorFetchingData(error, message)
			})
	}

	errorAlert = (text) => {
		return swal({
			title: "Data validation",
			text: text,
			icon: "warning",
			button: "Continue",
		})
	}


	saveSAPResource = () => {
		if (this.state.savingResource) {
			return
		}

		if (!this.state.title) {
			return this.errorAlert('Plese enter a title before saving')
		}

		if (this.state.isSAP === false && this.state.isProtocol === false) {
			return this.errorAlert('Please select either Protocol or SAP')
		}

		swal({
			text: "Saving SAP Resource",
			icon: require("../../../static/images/spinner.gif"),
			button: false
		})
		this.setState({ savingResource: true })
		const data = formatResourceForServer(this.state)
		const method = this.state.url ? 'PATCH' : 'POST'
		const url = this.state.url || `${getServerURL()}sap-resources/sap-resources/`
		const headers = { "Authorization": "Bearer " + localStorage.getItem("token") }

		axios({
			method,
			headers,
			url,
			data,
		})
			.then(response => {
				swal({
					title: "SAP Resource saved",
					icon: "success",
					button: "Continue",
				})
				this.setState({ savingResource: false }, () => {
					if (this.props.handleSaveSuccess) {
						this.props.handleSaveSuccess(response)
					}
				})
			})
			.catch(error => {
				this.setState({ savingResource: false }, () => {
					handleErrorFetchingData(error, "There was an error saving the SAP Resource")
					if (this.props.handleSaveError) {
						this.props.handleSaveError(error)
					}
				})
			})
	}

	render() {

		const spinner = require("../../../static/images/spinner.gif")

		const { 
			fetchingClients,
			fetchingSAPResourcesMetadata,
		} = this.props

		const metaDataTypes = [
			{ displayName: 'Therapeutic Areas', dataName: 'therapeuticAreas' },
			{ displayName: 'Designs', dataName: 'designs' },
			{ displayName: 'Data Sources', dataName: 'dataSources' },
			{ displayName: 'Methods', dataName: 'methods' },
			{ displayName: 'Content', dataName: 'contents' },
		]

		return (
			<div id="SAPResourceForm">
				<AuthenticationComponent />

				{fetchingClients || fetchingSAPResourcesMetadata ?
					<center>
						<div id="not-found">
							<img alt="loader" src={spinner} />
						</div>
					</center>
					:
					<Fragment>
						<Row>
							<center>
								<Button
									onClick={this.saveSAPResource}
									bsStyle="primary"
									disabled={this.state.savingResource}
								>
									Save
								</Button>
							</center>
						</Row>
						<p>
							<span className="required">*</span> denotes a required field
						</p>
						<Row>
							<Col xs={12} md={6}>
								<label className="control-label">
									Title <span className="required">*</span>
								</label>
								<FormControl
									value={this.state.title}
									className="title-form"
									type="text"
									onChange={(e) => this.handleChange('title', e.target.value)}
									placeholder="Enter title"
									disabled={this.state.savingResource}
								/>
							</Col>
						</Row>

						<br />
						
						<Row>
							<Col xs={12} md={6}>
								<label className="control-label">
									PTOR ID
								</label>
								<FormControl
									value={this.state.project}
									className="title-form"
									type="text"
									onChange={(e) => this.handleChange('project', e.target.value)}
									placeholder="Enter project"
									disabled={this.state.savingResource}
								/>
							</Col>
						</Row>

						<br />

						<Row>
							<Col xs={12} md={6}>
								<label className="control-label">
									Project Folder Path
								</label>
								<FormControl
									value={this.state.projectFolderPath}
									className="title-form"
									type="text"
									onChange={(e) => this.handleChange('projectFolderPath', e.target.value)}
									placeholder="Enter project folder path"
									disabled={this.state.savingResource}
								/>
							</Col>
						</Row>

						<br />

						<Row>
							<Col xs={12} md={6} style={{display: 'inline-block'}}>
								<label className="control-label">
                  Resource Type <span className="required">*</span>
                </label>
								<FormGroup>
									<Radio
										name="isSAP"
										inline
										checked={this.state.isSAP === true && this.state.isProtocol === false}
										disabled={this.state.savingResource}
										onChange={() => this.handleProtocolSAPChange('isSAP', !this.state.isSAP)}
									>
										SAP
									</Radio>
									<Radio
										name="isProtocol"
										inline
										checked={this.state.isProtocol === true && this.state.isSAP === false}
										disabled={this.state.savingResource}
										onChange={() => this.handleProtocolSAPChange('isProtocol', !this.state.isProtocol)}
									>
										Protocol
									</Radio>
									{' '}
									<Radio
										name="isBoth"
										inline
										checked={this.state.isSAP === true && this.state.isProtocol === true}
										disabled={this.state.savingResource}
										onChange={() => this.handleProtocolSAPChange('isBoth')}
									>
										SAP & Protocol
									</Radio>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col xs={12} sm={12} md={12} lg={12}>
								<label className="control-label">
									Authors
								</label>
								{/* <FormControl
									value={this.state.authors}
									className="title-form"
									type="text"
									onChange={(authors) => this.handleChange('authors', authors)}
									placeholder="Enter authors"
									disabled={this.state.savingResource}
								/> */}
								<Typeahead
									id="AuthorsTypeahead"
									clearButton
									multiple
									labelKey={user => `${user.first_name} ${user.last_name}`}
									renderMenuItemChildren={this._renderMenuItemChildren}
									selected={this.state.authors}
									options={this.props.genesisUsers}
									placeholder="Authors"
									onChange={authors => this.handleChange('authors', authors)}
									disabled={this.state.savingResource}
								/>
							</Col>
						</Row>

						<br />

						<Row>
							<Col xs={12} sm={12} md={12} lg={12}>
								<div>
									<label className="control-label">
										External Client
									</label>
									<Typeahead
										id="ExternalClientTypeahead"
										clearButton
										labelKey={client => `${client.name} ${client.short_code}`}
										selected={this.state.externalClient}
										options={this.props.clients}
										placeholder="External Client"
										onChange={client => this.handleChange('externalClient', client)}
										disabled={this.state.savingResource}
									/>
									<br />
								</div>
							</Col>
						</Row>

						{metaDataTypes.map(type => {
							if (!this.props[type.dataName] || !this.state[type.dataName]) {
								return null
							}
							return (
								<Row key={`${type.dataName}Typeahead`}>
									<Col xs={12} sm={12} md={12} lg={12}>
										<div>
											<label className="control-label">{type.displayName}</label>
											<Typeahead
												id={`${type.dataName}MetadataTypeahead`}
												clearButton 
												labelKey="name"
												allowNew={type.dataName !== 'therapeuticAreas' && type.dataName !== 'designs'}
												multiple
												selected={this.state[type.dataName]}
												options={this.props[type.dataName]}
												placeholder={type.displayName}
												onChange={(value) => this.handleChange(type.dataName, value)}
												disabled={this.state.savingResource}
											/>
											<br />
										</div>
									</Col>
								</Row>
							)
						})}

						<br />

						<Row>
							<Col xs={12} sm={12} md={12} lg={12}>
								<label className="control-label">
									Notes
								</label>
								<ReactQuill
									value={this.state.text}
									theme="snow"
									placeholder="Enter text"
									onChange={(text) => this.handleChange('text', text)}
									style={{ minHeight: '200px' }}
									readOnly={this.state.savingResource}
								/>
							</Col>
						</Row>

						{this.state.removeableDocuments.length && this.state.removeableDocuments.length > 0 ?
							<Fragment>
								<br />
								<label>Remove files</label>
								{this.state.removeableDocuments.map(doc => {
									return (
										<Fragment key={doc.id}>
											<br />
											<FileWithOverlay
												file={doc}
												overlayText="Are you sure you want to delete this document?"
												removeFile={() => this.deleteDocument(doc.url)}
											/>
										</Fragment>
									)
								})}
								<br />
								<br />
							</Fragment>
							:
							null
						}

						<br />
						
						<Row>
							<Col xs={12} sm={12} md={12} lg={12}>
								<center>
									<label>Upload Documents</label>
								</center>
								<FileUploader
									allowMultiple={true}
									filesForUpload={this.state.documents}
									handleFileDrop={this.addDocuments}
									removeFile={(document, index) => this.removeDocument(index)}
									disabled={this.state.savingResource}
								/>
							</Col>
						</Row>

						<br />

						<div>
							<Button
								onClick={this.saveSAPResource}
								bsStyle="primary"
								disabled={this.state.savingResource}
							>
								Save
							</Button>
						</div>

						<br />
						<br />
						<br />
					</Fragment>
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		currentUser: state.manageLogin.user,
		clients: state.manageLogin.clients,
		genesisUsers: state.manageLogin.genesisUsers,
		fetchingClients: state.manageLogin.fetchingClients,

		fetchingSAPResourcesMetadata: state.manageSAPResources.fetchingSAPResourcesMetadata,
		contents: state.manageSAPResources.contents,
		dataSources: state.manageSAPResources.dataSources,
		designs: state.manageSAPResources.designs,
		methods: state.manageSAPResources.methods,
		therapeuticAreas: state.manageSAPResources.therapeuticAreas,
	}
}

const mapDispatchToProps = {
	getClients,
	getUsers,
	getSAPResourcesMetadata,
}

export default connect(mapStateToProps, mapDispatchToProps)(SAPResourceForm)



// WEBPACK FOOTER //
// ./src/routes/sap-resources/components/SAPResourceForm.js